<template>
  <q-dialog
    v-model="show"
    :maximized="maximized"
    @input="(val) => $emit('input', val)"
  >
    <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title
            >Finalizar Atendimento - {{ protocol }}</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
      </q-header>
      <q-page-container style="max-height: 85vh" class="scroll">
        <q-input
        v-model="message"
        label="Observação"
        type="textarea" />

      </q-page-container>
      <div class="row full-width q-col-gutter-lg justify-center q-py-md">
          <div class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="info" @click="onFinish">
              <q-icon name="close" size="25px"/>
              Finalizar
            </q-btn>
          </div>
        </div>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestController from '../ServiceRequestController'
import ServiceRequestModel from '../ServiceRequestModel'
import { JtCrud } from 'jtech-webcomps'
import ServiceObservationController from './registration-information/service-observation/ServiceObservationController'
import { messageBox } from 'jtech'
const { modal } = JtCrud

@Component({
  name: 'ServiceRequestModalFinish',
  components: { 'crud-modal': modal },
  props: {
    protocol: String,
    show: {
      type: Boolean,
      default: false
    }
  }
})
class ServiceRequestModalFinish extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();
  controllerObservation = ServiceObservationController.getInstance();
  message = '';
  onFinish () {
    if (!this.message || this.message === '') {
      messageBox.warn(this.$gettext('SERVICE_OBSERVATION_OBRIGATORY_MESSAGE'))
      return
    }
    this.controller.finishEnd({ message: this.message, protocol: this.protocol })
  }
}
export default ServiceRequestModalFinish
</script>
<style lang="stylus" scoped></style>
